import { MouseEvent } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import HeroStage from './HeroStage';
import { useSectionNav } from './useSectionNav';

const TECH = ['Go', 'Python', 'PostgreSQL', 'Redis', 'Docker', 'Nginx', 'Linux', 'TypeScript', 'Next.js', 'Vue', 'FortiGate', 'Cisco'];

function Hero() {
  const { t } = useLanguage();
  const goTo = useSectionNav();

  const onSeeWork = (e: MouseEvent) => {
    e.preventDefault();
    goTo('work');
  };

  return (
    <>
      <section id="top" className="hero">
        <div className="hero-copy">
          <div className="eyebrow eyebrow-acc ld ld-2">{t.hero.eyebrow}</div>
          <h1 className="hero-title ld ld-3">
            {t.hero.h1} <span className="dim">{t.hero.h1b}</span>
          </h1>
          <p className="hero-text ld ld-4">{t.hero.p}</p>
          <div className="hero-actions ld ld-5">
            <a href="/#work" className="btn btn-solid" onClick={onSeeWork}>
              {t.hero.seeWork}
            </a>
            <a href={process.env.PUBLIC_URL + '/ft-new-cv.pdf?v=2026-09'} className="btn btn-line" target="_blank" rel="noreferrer">
              {t.hero.resume}
            </a>
          </div>
        </div>
        <div className="hero-stage ld-stage">
          <HeroStage />
        </div>
      </section>

      <div className="tech-strip">
        <div className="rv-line tech-strip-line" />
        <div className="rv tech-strip-items">
          {TECH.map((name, i) => (
            <span key={name} className={i === 0 ? 'first' : ''}>
              {name}
            </span>
          ))}
        </div>
      </div>
    </>
  );
}

export default Hero;
